import React from "react";
import moment from "moment";

import pullAll = require("lodash/pullAll");
import {Link} from "react-router";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {ZzIconButtonMenu, ZzMenuItem} from "core/components/buttons/icons";
import MenuItem from 'material-ui/MenuItem';
import mdEntityService from "core/metamodel/mdEntityService";
import invoiceService, {invoiceTemplateItemGridLocation} from "invoice/service/invoiceService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import Form from "core/form/form";
import {replaceIdWithLov, lovLabel, lovValue, preSave, formatValue, IDomainObject} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridComp from "core/grid/component/gridComp";
import Grid, {ClientGrid, GridRow} from "core/grid/domain/grid";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import InvoiceTemplateItemForm from "invoice/component/invoiceTemplateItemForm";
import {UNIT_OF_MEASURE} from "product/productUtils";
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, SECURABLE_TYPE, SECURABLE, PageProps, ID} from "core/metamodel/metaConstant";
import "invoice/page/invoiceDetail.less";
import {observer} from "mobx-react";
import {
  Invoice, INVOICESTATUS, InvoiceItem, INVOICE_TYPE,
  INVOICEITEMTYPE, canDeleteInvoiceDocument, InvoiceTemplate, InvoiceTemplateItem, PAYMENT_TYPE
} from "invoice/domain/invoiceDomain";
import {ObservableMap, action, observable} from "mobx";
import {GridLocation} from "core/grid/domain/grid";
import {MovingBlocks} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {UILOCATION} from "core/grid/component/gridComp";
import InvoiceTemplateForm from "invoice/component/invoiceTemplateForm";
import InvoiceTemplateSumTable from "invoice/component/invoiceTemplateSumTable";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import {loc} from "../../core/common/config/locales";
import InvoiceTemplateBilledToDialog from "../component/invoiceTemplateBilledToDialog";
import {nonReplacedDocumentFp} from "core/document/documentDomain";


@observer
export default class InvoiceTemplateDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.invoicing;
  static title = 'Invoice Template';
  static icon = 'money';
  static protectedPage = true;

  @observable billedToDialogOpen = false;


  static fetchData(routerParams, query) {
    console.log("InvoiceTemplateDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['InvoiceTemplate', 'InvoiceTemplateItem'], ['Invoice', {entity: "EventType", lov: true}]);

    let invoiceTemplatePromise: Promise<InvoiceTemplate>;

    if (routerParams.id === 'new') {
      invoiceTemplatePromise = Promise.resolve(new InvoiceTemplate({
        $new: true,
        active: true,
        invoiceAdjustmentKoef: 0
      }));
    } else if (routerParams.id === 'copy') {
      invoiceTemplatePromise = invoiceService.readInvoiceTemplate(query.copyId, {mode: 'copy'})
        .then( (invoiceTemplateObject: InvoiceTemplate) => {
          invoiceTemplateObject.cleanOnCopy();
          invoiceTemplateObject.invoiceTemplateId = undefined;

          invoiceTemplateObject.items.forEach(t => {
            t.invoiceTemplate = undefined;
            t.invoiceTemplateItemId = undefined;
          });

          return invoiceTemplateObject;
        });
    } else {
      invoiceTemplatePromise = invoiceService.readInvoiceTemplate(routerParams.id);
    }

    let gridPromise = gridService.fetchGrids(invoiceTemplateItemGridLocation);

    return Promise.all([metadataPromise, invoiceTemplatePromise, gridPromise])
      .then(([entityMap, invoiceTemplateObject, gridLocationMap]: [ObservableMap<MdEntity>, InvoiceTemplate, ObservableMap<GridLocation>]) => {
        invoiceTemplateObject.$new = !invoiceTemplateObject.invoiceTemplateId;

        if (!invoiceTemplateObject.holidayHandling) invoiceTemplateObject.holidayHandling = entityMap.get("HOLIDAYHANDLING").getLovItem("ALWAYS");
        if (!invoiceTemplateObject.paymentType) invoiceTemplateObject.paymentType = entityMap.get("PaymentType").getLovItem(PAYMENT_TYPE.ACCOUNT_TRANSFER);
        if (!invoiceTemplateObject.remittanceSkipCount) invoiceTemplateObject.remittanceSkipCount = 1;
        if (!invoiceTemplateObject.remittanceType) invoiceTemplateObject.remittanceType = entityMap.get("REMITTANCETYPE").getLovItem("MONTH");
        if (!invoiceTemplateObject.validFrom) invoiceTemplateObject.validFrom = new Date(new Date().setHours(0, 0, 0, 0));


        invoiceTemplateObject.$movingBlocks = new MovingBlocks(null, false, null,
          new ClientGrid<InvoiceTemplateItem>(gridLocationMap.get(invoiceTemplateItemGridLocation), "items", invoiceTemplateObject.invoiceTemplateId));

        invoiceService.invoiceTemplateObject = invoiceTemplateObject.initAfterRead(routerParams.id === 'new');
      });
  }




  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(prevProps.params.id !== this.props.params.id) {
      invoiceService.invoiceTemplateObject.$movingBlocks.searchExposedGrids(invoiceService.invoiceTemplateObject);
    }
  }

  componentDidMount() {
    invoiceService.invoiceTemplateObject.$movingBlocks.searchExposedGrids(invoiceService.invoiceTemplateObject);
  }

  componentWillUnmount() {
    invoiceService.invoiceTemplateObject = null;
  }



  customValidate = (invoiceTemplateObject: InvoiceTemplate) => {
    let errors = [];

    let today = moment().startOf('day');
    if (!invoiceTemplateObject.disableScheduling && !invoiceTemplateObject.lastGenerateDate && moment(invoiceTemplateObject.validFrom).isBefore(today)) {
      errors.push({message: "Starting date cannot be in the past"})
    }

    return errors;
  };


  findRootObject() {
    return invoiceService.invoiceTemplateObject;
  }


  commitOpenItems(grid: Grid) {
    if (grid.data) {
      for (let row of grid.data.flatRows()) {
        let rowObject: InvoiceTemplateItem = row.rowObject as InvoiceTemplateItem;
        if (rowObject && rowObject.$added) {
          invoiceService.invoiceTemplateObject.items.push(rowObject);
        }
      }
    }
  }


  @action onSave = (evt) => {
    console.log('onSave invoiceTemplateId = %s, $new = %s', invoiceService.invoiceTemplateObject.invoiceTemplateId, invoiceService.invoiceTemplateObject.$new);
    uiService.showToolbarActionFlag();

    // remove invoice period if it was disabled
    if (!invoiceService.invoiceTemplateObject.periodicInvoice) {
      invoiceService.invoiceTemplateObject.startInvoicePeriodExpression = null;
      invoiceService.invoiceTemplateObject.endInvoicePeriodExpression = null;
    }


    // pridame do invoiceObject.items z otevrenych formu na gridu
    let grid = invoiceService.invoiceTemplateObject.$movingBlocks.getBlock(invoiceTemplateItemGridLocation) as ClientGrid<InvoiceTemplateItem>;
    this.commitOpenItems(grid);


    let result = preSave(invoiceService.invoiceTemplateObject, this.customValidate, true);
    if (!result) {
      return;
    }

    invoiceService.invoiceTemplateSave(invoiceService.invoiceTemplateObject)
      .then(action("invoiceTemplateSave-action", (invoiceTemplateJson: IDomainObject) => {

        let wasNew = invoiceService.invoiceTemplateObject.cleanAfterSave(invoiceTemplateJson);

        console.log("invoiceService.invoiceTemplateObject.nextGenerateDate = ", invoiceService.invoiceTemplateObject.nextGenerateDate);

        if(wasNew) {
          this.context.router.replaceWith('invoiceTemplateDetail', {id: invoiceService.invoiceTemplateObject.invoiceTemplateId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        invoiceService.invoiceTemplateObject.$errors = error.getMessages();
      });

  };





  onAdd = (evt) => {
    console.log('onAdd');
    let query = {};
    this.context.router.transitionTo("invoiceTemplateDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("invoiceTemplateDetail", {id: 'copy'}, {copyId: invoiceService.invoiceTemplateObject.invoiceTemplateId});
  };

  @action onDelete = (evt) => {
    console.log('onDelete');

    invoiceService.deleteInvoiceTemplate(invoiceService.invoiceTemplateObject.invoiceTemplateId)
      .then(response => {
        this.goBackOrHome();
      }, error => {
        invoiceService.invoiceTemplateObject.$errors = error.getMessages();
      });
  };

  @action onGenerateInvoice = (evt) => {
    if (invoiceService.invoiceTemplateObject.billedTo == null) {
      this.billedToDialogOpen = true;
    } else {
      this.generateInvoice();
    }
  }

  @action onBilledToDialogConfirm = (billedTo: LovItem) => {
    this.billedToDialogOpen = false;
    this.generateInvoice(billedTo.value);
  }

  @action onBilledToDialogClose = () => {
    this.billedToDialogOpen = false;
  }

  @action generateInvoice = async (billedTo?: ID) => {
    const invoiceTemplate = invoiceService.invoiceTemplateObject;
    uiService.showToolbarActionFlag();
    invoiceService.generateInvoiceFromTemplate(invoiceTemplate.invoiceTemplateId, billedTo as number)
      .then(action("generateInvoiceAction", (invoice: Invoice) => {
        uiService.hideToolbarActionFlag();
        window.location.href = `/invoice/detail/${invoice.invoiceId}`;
      }), error => {
        console.error(error);
        invoiceService.invoiceObject.$errors = error.getMessages();
      });
  }


  @action addInvoiceTemplateItem = (itemType: string) => {
    console.log('addInvoiceItem %s', itemType);

    let grid = invoiceService.invoiceTemplateObject.$movingBlocks.getBlock(invoiceTemplateItemGridLocation) as ClientGrid<InvoiceTemplateItem>;

    let rowObject = new InvoiceTemplateItem({
      invoiceTemplate: invoiceService.invoiceTemplateObject.invoiceTemplateLov(),
      adjustmentKoef: 0,
      adjustmentAmount: 0,

      $new: true,
      $dirty: true,
      $added: true,
      itemType: replaceIdWithLov(itemType, mdEntityService.getEntity('INVOICEITEMTYPE'))
    });

    if (itemType !== INVOICEITEMTYPE.FREEITEM) {
      rowObject.quantity = 1;
      rowObject.unitOfMeasure = replaceIdWithLov(UNIT_OF_MEASURE.pcs, mdEntityService.getEntity('UnitOfMeasure'));
    }

    grid.addRow(rowObject);
    let form: Form<InvoiceTemplateItem> = rowObject.getForm('InvoiceTemplateItemForm');
    form.$open = true;

    invoiceService.invoiceTemplateObject.$dirty = true;
  };



  @action recalculateInvoiceTemplate = (rootObject: InvoiceTemplate, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: { [key: string]: any }): Promise<any> => {
    uiService.showToolbarActionFlag();

    if ((toDeleteRows != null && rootObject.items.length - toDeleteRows.length == 0)
    || rootObject.items.length == 0) {
      invoiceService.invoiceTemplateObject.disableScheduling = true;
      let form: Form<InvoiceTemplate> = rootObject.getForm('InvoiceTemplateForm');
      form.updateFieldsPropValue(rootObject, 'disableScheduling');
    }

    if (modifiedRows) {
      for(let row of modifiedRows) {
        if (row.rowObject.$added) {
          invoiceService.invoiceTemplateObject.items.push(row.rowObject as any);
        }
      }
    }

    if (toDeleteRows) {
      pullAll(invoiceService.invoiceTemplateObject.items, toDeleteRows.map(row => row.rowObject));
    }

    return invoiceService.recalculateTemplateWithClean(invoiceService.invoiceTemplateObject, params)
      .then(action("recalculateTemaplteWithClean-actionCb", () => {
        let grid = invoiceService.invoiceTemplateObject.$movingBlocks.getBlock(invoiceTemplateItemGridLocation) as Grid;
        grid.$dirty = true;
        invoiceService.invoiceTemplateObject.$dirty = true;
        uiService.hideToolbarActionFlag();
      }));

  };


  @action copyInvoiceTemplateItem = (invoiceTemplateItem: InvoiceTemplateItem): IDomainObject => {
    invoiceTemplateItem.invoiceTemplateItemId = undefined;
    invoiceTemplateItem.dateCreated = undefined;
    invoiceTemplateItem.dateUpdated = undefined;
    invoiceTemplateItem.userCreated = undefined;
    invoiceTemplateItem.tenantId = undefined;

    return invoiceTemplateItem;
  };



  render() {

    const {
      query,
    } = this.props;

    let invoiceTemplateObject = invoiceService.invoiceTemplateObject;
    let invoiceTemplateEntity = mdEntityService.getEntity('InvoiceTemplate');

    const propsForCreateForm = {
      dataObject: invoiceTemplateObject,
      rootObject: invoiceTemplateObject,
      entity: invoiceTemplateEntity,
      entities: mdEntityService.entityMap
    };

    console.log('invoiceTemplateDetail render invoiceId = %s, $new = %s', invoiceTemplateObject.invoiceTemplateId, invoiceTemplateObject.$new);


    const rowInvoiceTemplateItemForm = (
      <InvoiceTemplateItemForm rootObject={invoiceTemplateObject} entity={mdEntityService.getEntity('InvoiceTemplateItem')}
                       entities={mdEntityService.entityMap}
                       dataObject={null}/>
    );


    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        <InvoiceTemplateBilledToDialog dialogOpen={this.billedToDialogOpen} onConfirm={this.onBilledToDialogConfirm} onClose={this.onBilledToDialogClose} />

        {this._createToolMenu(invoiceTemplateObject, query.gridLocation)}
        <ErrorComp messages={invoiceTemplateObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        <InvoiceTemplateForm {...propsForCreateForm} recalculate={this.recalculateInvoiceTemplate} />

        <InvoiceTemplateSumTable invoiceTemplateObject={invoiceTemplateObject} entities={mdEntityService.entityMap} invoiceTemplateEntity={invoiceTemplateEntity}
                         style={{minWidth: '50%', margin: "10px 20px"}}/>

        <GridComp ref={invoiceTemplateItemGridLocation} grid={invoiceTemplateObject.$movingBlocks.getBlock(invoiceTemplateItemGridLocation) as Grid}
                  uiLocation={UILOCATION.main}
                  showEdit showDelete
                  deleteRowIcon="fa fa-trash" rootObject={invoiceTemplateObject}
                  editForm={rowInvoiceTemplateItemForm} editFormName="InvoiceTemplateItemForm" entities={mdEntityService.entityMap}
                  editOverrideFn={this.recalculateInvoiceTemplate} copyRowObjectFn={this.copyInvoiceTemplateItem}
                  multiUpdateSaveFn={this.onSave}>

          <ZzIconButtonMenu buttonIcon={<Add/>}
                            disabled={!invoiceTemplateObject.invoiceCurrency }>
            <MenuItem primaryText="Free Item" onClick={this.addInvoiceTemplateItem.bind(this, INVOICEITEMTYPE.FREEITEM)}/>
            <MenuItem primaryText="Product" onClick={this.addInvoiceTemplateItem.bind(this, INVOICEITEMTYPE.PRODUCTITEM)}/>
            <MenuItem primaryText="Product & Vehicle"
                      onClick={this.addInvoiceTemplateItem.bind(this, INVOICEITEMTYPE.PRODUCTVEHICLEITEM)}/>
          </ZzIconButtonMenu>

        </GridComp>

      </main>





    );
  }


  _createToolMenu(invoiceTemplateObject: InvoiceTemplate, gridLocation: string) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} historize
                entityName="InvoiceTemplate" entityId={invoiceTemplateObject.invoiceTemplateId}>
        <ZzFlatButton onClick={this.onSave} disabled={!invoiceTemplateObject.$dirty} label="Save" permission={invoiceTemplateObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={invoiceTemplateObject.$new} label="New" permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={invoiceTemplateObject.$new} label="Copy" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="InvoiceTemplate" pageAncestor={this} onClick={this.onDelete} disabled={invoiceTemplateObject.$new} label="Delete" permission={PERMISSION.Delete}/>
        <ZzFlatButton onClick={this.onGenerateInvoice} disabled={invoiceTemplateObject.$new} label={loc.i18n`Generate Invoice`} />
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/invoice/page/invoiceTemplateDetail.tsx